import React from 'react';

import Button, { ButtonColor } from '@geobank/components/src/common/Button/Button';

import { ReactComponent as ArrowLeftIcon } from './chevron_left-black-18dp.svg';
import { ReactComponent as ArrowRightIcon } from './chevron_right-black-18dp.svg';
import styles from './TablePagination.module.scss';

interface TablePaginationProps {
  count: number;
  page: number;
  rowsPerPage?: number;
  onPageChange: (newPage: number) => void; // onChangePage
  // rowsPerPageOptions?: string[];
  // onRowsPerPageChange?: (newRowsPerPage: number) => void;
  captionRender?: (page: number, rowsPerPage: number, totalCount: number) => JSX.Element | string;
}

const defaultCaptionRender = (currentPage: number, rowsPerPage: number, totalCount: number) => {
  return `${(currentPage - 1) * rowsPerPage + 1}-${currentPage * rowsPerPage} из ${totalCount}`;
};

const TablePagination: React.FC<TablePaginationProps> = props => {
  const {
    count,
    page,
    rowsPerPage = 10,
    onPageChange,
    captionRender = defaultCaptionRender,
  } = props;
  // const rowsPerPage = props.rowsPerPage || 10;

  // const isFirstPage = (_page: number) => _page <= 1;
  // const isLastPage = (_page: number) => _page >= Math.ceil(count / rowsPerPage);

  const handlePageChange = (newPage: number) => {
    console.log(newPage);
    // if (!isFirstPage(newPage) && !isLastPage(newPage)) {
    if (newPage > 0 && newPage < Math.ceil(count / rowsPerPage) + 1) {
      onPageChange(newPage);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        {/* <div className={styles.xxx}>rowsPerPageOptions TODO</div> */}
        <div className={styles.pagingCaption}>
          {/* {renderCaption()} */}
          {/* {`${(page - 1) * rowsPerPage + 1}-${page * rowsPerPage} из ${count}`} */}
          {captionRender(page, rowsPerPage, count)}
        </div>
        <div className={styles.pagingControls}>
          <Button color={ButtonColor.TRANSPARENT} onClick={handlePageChange.bind(null, page - 1)}>
            <ArrowLeftIcon fill="currentColor" color="#3373c6" />
          </Button>
          <Button color={ButtonColor.TRANSPARENT} onClick={handlePageChange.bind(null, page + 1)}>
            <ArrowRightIcon fill="currentColor" color="#3373c6" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TablePagination;
